import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'CTLRecoverPassword',
            headers: {},
            args: {
                password: payload.password,
                confirm: payload.confirm,
            },
            urlArgs: {
                passcode: payload.passcode,
            },
        });
        return result;
    };
};
